
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Restaurant } from '@/api/model';
import FormGroup from '@/components/profile/FormGroup.vue';
import MessageToastMixin from '@/mixins/MessageToastMixin';

@Component({
  components: { FormGroup },
})
export default class RestaurantForm extends Mixins(MessageToastMixin) {
  formGroup: any = {
    active: false,
    fields: [
      { name: 'restaurantName' },
      { name: 'restaurantType', type: 'restaurant-type' },
      { name: 'restaurantSeats' },
      { name: 'restaurantTelephone' },
      { name: 'restaurantWebsite' },
      { name: 'restaurantStreet' },
      { name: 'restaurantNumber' },
      { name: 'restaurantPostalcode' },
      { name: 'restaurantCity' },
      { name: 'restaurantCountry', type: 'country' },
    ],
  };

  saving = false;

  @Prop(Object)
  restaurant!: Restaurant;

  // Is the form initially active (for add restaurant)
  @Prop(Boolean)
  initActive!: boolean;

  @Prop(Boolean)
  active!: boolean;

  @Watch('active')
  activeChanged() {
    if (this.active === false) {
      this.cancel();
    }
  }

  created() {
    if (this.initActive) {
      this.edit();
    }
  }

  deleteRestaurant(id: string) {
    this.$buefy.dialog.confirm({
      title: this.$t('profile.restaurant.delete.title') as string,
      message: this.$t('profile.restaurant.delete.message') as string,
      confirmText: this.$t('profile.restaurant.delete.confirm') as string,
      cancelText: this.$t('profile.label.cancel') as string,
      canCancel: true,
      hasIcon: true,
      icon: 'delete',
      iconPack: 'lwm',
      type: 'is-danger',
      onConfirm: () => {
        this.$store.dispatch('restaurant/deleteRestaurant', id);
        this.showSuccess(this.$t('profile.restaurant.delete.success'));
      },
    });
  }

  edit() {
    this.$store.commit('restaurant/setActiveRestaurantId', this.restaurant.id);
    this.formGroup.active = true;
  }

  cancel() {
    if (this.restaurant.id === undefined) {
      this.$store.commit('restaurant/deleteRestaurant');
    }
    this.formGroup.active = false;
  }

  setField(fieldName: string, value: string) {
    const field = this.formGroup.fields.find((f: any) => f.name === fieldName);
    field.value = value;
  }

  async save() {
    this.saving = true;
    try {
      const newFields: any = {};
      this.formGroup.fields.forEach((f: any) => {
        if (f.value !== undefined) {
          newFields[f.name] = f.value;
        }
      });
      const newRestaurant = Object.assign(this.restaurant, newFields);
      await this.$store.dispatch('restaurant/saveRestaurant', newRestaurant);
      this.showSuccess(this.$t('profile.restaurant.save-success'));
      this.formGroup.active = false;
    } catch (e) {
      this.showError(this.$t('general.messages.error'));
    }
    this.saving = false;
  }

  getDisplayValue(field: any): string {
    const fieldName: any = field.name;
    // @ts-ignore
    const value: string = this.restaurant[fieldName];
    if (field.type === 'restaurant-type' && value) {
      return this.$t(`profile.restaurant.type.${value}`) as string;
    }
    return value;
  }
}
